import FormEditOrAssignPermissions from './FormEditOrAssignPermissions';
import { IEmployee, IHasErrorMessage } from '@/interfaces';

export default FormEditOrAssignPermissions;

export type TFormData = Omit<
  IEmployee,
  | 'updatedAt'
  | 'createdAt'
> & IHasErrorMessage & {
  selectedEmployeeId?: string;
  filter: {
    usernameOrEmail: string;    
  }
};
